import { FlowDirectionKey } from "./flowMapTypes";

// Whether an arrow's panel offers field-mapping rules, and which route record
// those rules belong to.
//
// Both directions can carry rules, but they live on different route records: the
// outgoing flow's rules are part of THIS Route's configuration, while the
// incoming flow's belong to the reverse Route — the separate record the
// direction toggle creates. So the "in" arrow can only offer rules once that
// record exists (the direction is enabled and its configuration was resolved).
export const arrowOffersRules = ({ direction, state, reverseRecordExists }: {
    direction: FlowDirectionKey;
    state?: string;
    reverseRecordExists?: boolean;
}): boolean => direction === "out" || (state === "enabled" && !!reverseRecordExists);
